import React from 'react';
import { AdminPanel } from '../components/AdminPanel';

export const DashboardPage: React.FC = () => {
  return <AdminPanel />;
};
